import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from './../../../utils/flash/index';
import commissionService from "./commissionService";

const initialState = {
    all_comissions: [],
    isLoading: false,
    isSuccess: false,
    createSuccess: false,
    isError: false,
    isUpdated: false,
    commission: null,
    isSingleSuccess: false,
}

export const commissionSlice = createSlice({
    name: 'commission',
    initialState,
    reducers: {
        resetCommissionStatus: (state) => {
            state.isError = false
            state.isSuccess = false
            state.createSuccess = false
            state.isLoading = false
            state.isUpdated = false
            state.isSingleSuccess = false
        },
        resetSingleCommission: (state) => {
            state.commission = null
        },
        resetCommission: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
        // Create direct Commission
            .addCase(createCommission.pending, (state) => {
                state.isLoading = true
                flash("info", "Commission is being created");
            })
            .addCase(createCommission.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.message){
                    state.isError = false;
                    state.createSuccess = true;
                    flash("success", "Commission created successfully");
                }else if (action.payload.errors.name) {
                    state.isError = true;
                    state.message = action.payload.error;
                    flash("error", action.payload.errors.name[0]);
                } else if (action.payload.errors) {
                    state.isError = true;
                    state.message = action.payload.error;
                    flash("error", action.payload.errors.comission_name[0]);
                }
            })
            .addCase(createCommission.rejected, (state, action) =>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            // create segmented commission
            .addCase(createSegmentedCommission.pending, (state) => {
                state.isLoading = true
                flash("info", "Commission is being created");
            })
            .addCase(createSegmentedCommission.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.message){
                    state.isError = false;
                    state.createSuccess = true;
                    flash("success", "Commission created successfully");
                } else if (action.payload.errors.name) {
                    state.isError = true;
                    state.message = action.payload.error;
                    flash("error", action.payload.errors.name[0]);
                } else if (action.payload.errors) {
                    state.isError = true;
                    state.message = action.payload.error;
                    flash("error", action.payload.errors[0]);
                }
            })
            .addCase(createSegmentedCommission.rejected, (state, action) =>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            // get all commission
            .addCase(getAllCommissions.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllCommissions.fulfilled, (state, action) => {
                state.isLoading = false
                if (action.payload.errors) {
                    state.isError = true;
                    state.message = action.payload.error;
                    flash("error", action.payload.errors[0]);
                } else {
                    state.isError = false;
                    state.isSuccess = true;
                    state.all_commissions = action.payload.comissions
                }
            })
            .addCase(getAllCommissions.rejected, (state, action) =>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            // get single commission
            .addCase(getSingleCommission.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getSingleCommission.fulfilled, (state, action) => {
                state.isLoading = false
                if (action.payload.errors) {
                    state.isError = true;
                    state.message = action.payload.error;
                    flash("error", action.payload.errors[0]);
                } else {
                    state.isError = false;
                    state.isSingleSuccess = true;
                    state.commission = action.payload
                }
            })
            .addCase(getSingleCommission.rejected, (state, action) =>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            // update direct commission
            .addCase(updateDirectCommission.pending, (state) => {
                state.isLoading = true
                flash("info", "Updating Commission");
            })
            .addCase(updateDirectCommission.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.message){
                    state.isUpdated = true;
                    flash("success", "Commission updated successfully")
                } else if (action.payload.errors) {
                    state.isError = true;
                    state.message = action.payload.error;
                    flash("error", action.payload.errors[0]);
                }
            })
            .addCase(updateDirectCommission.rejected, (state, action) =>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            // update segmented commission
            .addCase(updateSegmentedCommission.pending, (state) => {
                state.isLoading = true
                flash("info", "Updating Commission");
            })
            .addCase(updateSegmentedCommission.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.message){
                    flash("success", "Commission updated successfully")
                    state.isUpdated = true;
                } else if (action.payload.errors) {
                    state.isError = true;
                    state.message = action.payload.error;
                    flash("error", action.payload.errors[0]);
                }
            })
            .addCase(updateSegmentedCommission.rejected, (state, action) =>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            
    } 
})

// Create commission
export const createCommission = createAsyncThunk('/commission/create', async(commissionData, thunkAPI) => {
    try {
        return await commissionService.createCommission(commissionData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

// Create commission
export const createSegmentedCommission = createAsyncThunk('/commission/create_segmented', async(commissionData, thunkAPI) => {
    try {
        return await commissionService.createSegmentedCommission(commissionData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

// Get all commission
export const getAllCommissions = createAsyncThunk('/commission/getAll', async(pageNumber, thunkAPI) => {
    try {
        return await commissionService.getAllCommissions(pageNumber)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})
// Get single commission
export const getSingleCommission = createAsyncThunk('/commission/getSingle', async(id, thunkAPI) => {
    try {
        return await commissionService.getSingleCommission(id)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})
// Update direct commission
export const updateDirectCommission = createAsyncThunk('/commission/updateDirect', async(data, thunkAPI) => {
    try {
        return await commissionService.updateDirctCommission(data)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})
// Get all commission
export const updateSegmentedCommission = createAsyncThunk('/commission/updateSegmented', async(data, thunkAPI) => {
    try {
        return await commissionService.updateSegmentedCommission(data)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const { resetCommissionStatus, resetCommission, resetSingleCommission } = commissionSlice.actions
export default commissionSlice.reducer